import { useField } from 'formik';
import React, {useState} from 'react';
import { isReadOnly } from 'utilities/JSUtil';
import '../Form.scss';
import TextInput from "../TextInput/TextInput";
import './OperatingHours.scss'

function disableAllForDay(day, val, detailedOperatingHours, mealType) {
    for (const [key, value] of Object.entries(detailedOperatingHours)) {
        if (key === 'dailyDoesntVary') {
            continue;
        }
        if ((mealType === undefined && key == 'DAILY') || (mealType !== undefined && key !== 'DAILY')) {
            value.hours[day].closed = !val;
            value.hours[day].open = '';
            value.hours[day].close = '';
        }
    }
}

const OperatingHours = ({ label, ...props }) => {
    const [field, meta, helpers] = useField(props);
    const [tableDisabled, setTableDisabled] = props.cellName ? useState(!props.tableDissabled) : useState(false)
    let cellName = props.cellName
    let detailedOperatingHours = props.allValues;
    let idCellName = cellName ? cellName.toLocaleLowerCase() : undefined
    let splitNameOne = undefined;
    let splitNameTwo = undefined;
    if (cellName && cellName.includes(' ')) {
        splitNameOne = cellName.split(' ')[0];
        splitNameTwo = cellName.split(' ')[1];
        idCellName = splitNameOne.toLocaleLowerCase() + splitNameTwo;
    }
    return (
        <table className='hotel-content-table table table-striped table-bordered'>
            <thead>
            <tr>
                {
                    cellName && <th className='falseCell'></th>
                }
                <th></th>
                <th>Monday</th>
                <th>Tuesday</th>
                <th>Wednesday</th>
                <th>Thursday</th>
                <th>Friday</th>
                <th>Saturday</th>
                <th>Sunday</th>
            </tr>
            </thead>
            <tbody>
            <tr>
                {
                    cellName && !splitNameOne
                    && <td rowSpan="1" className='falseCell titleCell alignBottom'> {cellName} </td>
                }
                {
                    cellName && splitNameOne
                    && <td rowSpan="1" className='falseCell titleCell alignBottom'> {splitNameOne} <br/> {splitNameTwo} </td>
                }
                <td>
                    Opening Time
                </td>
                <td>
                    <TextInput id={props.id + '.hours.mon.open'}
                               name={props.id + '.hours.mon.open'} className='monField' type='time' isrequired='true'
                               disabled={props.day.hours.mon.closed || tableDisabled} />
                </td>
                <td>
                    <TextInput id={props.id + '.hours.tue.open'}
                               name={props.id + '.hours.tue.open'} type='time' isrequired='true'
                               disabled={props.day.hours.tue.closed || tableDisabled} />
                </td>
                <td>
                    <TextInput id={props.id + '.hours.wed.open'}
                               name={props.id + '.hours.wed.open'} type='time' isrequired='true'
                               disabled={props.day.hours.wed.closed || tableDisabled} />
                </td>
                <td>
                    <TextInput id={props.id + '.hours.thu.open'}
                               name={props.id + '.hours.thu.open'} type='time' isrequired='true'
                               disabled={props.day.hours.thu.closed || tableDisabled} />
                </td>
                <td>
                    <TextInput id={props.id + '.hours.fri.open'}
                               name={props.id + '.hours.fri.open'} type='time' isrequired='true'
                               disabled={props.day.hours.fri.closed || tableDisabled} />
                </td>
                <td>
                    <TextInput id={props.id + '.hours.sat.open'}
                               name={props.id + '.hours.sat.open'} type='time' isrequired='true'
                               disabled={props.day.hours.sat.closed || tableDisabled} />
                </td>
                <td>
                    <TextInput id={props.id + '.hours.sun.open'}
                               name={props.id + '.hours.sun.open'} type='time' isrequired='true'
                               disabled={props.day.hours.sun.closed || tableDisabled} />
                </td>
            </tr>
            <tr>
                {
                    cellName &&
                    <td className='falseCell alignTop'>
                        <TextInput
                            id={idCellName + 'Checkbox'}
                            type='checkbox'
                            className='agree-checkbox'
                            name={idCellName + 'Checkbox'}
                            onClick={() => {setTableDisabled(!tableDisabled)}}
                            value={!tableDisabled}
                            checked={!tableDisabled} />
                    </td>
                }
                <td>
                    Closing Time
                </td>
                <td>
                    <TextInput id={props.id + '.hours.mon.close'}
                               name={props.id + '.hours.mon.close'} className='monField' type='time' isrequired='true'
                               disabled={props.day.hours.mon.closed || tableDisabled} />
                </td>
                <td>
                    <TextInput id={props.id + '.hours.tue.close'}
                               name={props.id + '.hours.tue.close'} type='time' isrequired='true'
                               disabled={props.day.hours.tue.closed || tableDisabled} />
                </td>
                <td>
                    <TextInput id={props.id + '.hours.wed.close'}
                               name={props.id + '.hours.wed.close'} type='time' isrequired='true'
                               disabled={props.day.hours.wed.closed || tableDisabled} />
                </td>
                <td>
                    <TextInput id={props.id + '.hours.thu.close'}
                               name={props.id + '.hours.thu.close'} type='time' isrequired='true'
                               disabled={props.day.hours.thu.closed || tableDisabled} />
                </td>
                <td>
                    <TextInput id={props.id + '.hours.fri.close'}
                               name={props.id + '.hours.fri.close'} type='time' isrequired='true'
                               disabled={props.day.hours.fri.closed || tableDisabled} />
                </td>
                <td>
                    <TextInput id={props.id + '.hours.sat.close'}
                               name={props.id + '.hours.sat.close'} type='time' isrequired='true'
                               disabled={props.day.hours.sat.closed || tableDisabled} />
                </td>
                <td>
                    <TextInput id={props.id + '.hours.sun.close'}
                               name={props.id + '.hours.sun.close'} type='time' isrequired='true'
                               disabled={props.day.hours.sun.closed || tableDisabled} />
                </td>
            </tr>
            <tr>
                {
                    cellName && <td className='falseCell'></td>
                }
                <td>
                    Closed
                </td>
                <td>
                    <TextInput
                        id={props.id + '.hours.mon.closed'}
                        type='checkbox'
                        className='agree-checkbox monClosed'
                        name={props.id + '.hours.mon.closed'}
                        onClick={() => {disableAllForDay('mon', props.day.hours.mon.closed, detailedOperatingHours, cellName);}}
                        value={props.day.hours.mon.closed}
                        checked={props.day.hours.mon.closed}
                        disabled={tableDisabled}
                    />
                </td>
                <td>
                    <TextInput
                        id={props.id + '.hours.tue.closed'}
                        type='checkbox'
                        className='agree-checkbox'
                        name={props.id + '.hours.tue.closed'}
                        onClick={() => {disableAllForDay('tue', props.day.hours.tue.closed, detailedOperatingHours, cellName);}}
                        value={props.day.hours.tue.closed}
                        checked={props.day.hours.tue.closed}
                        disabled={tableDisabled}
                    />
                </td>
                <td>
                    <TextInput
                        id={props.id + '.hours.wed.closed'}
                        type='checkbox'
                        className='agree-checkbox'
                        name={props.id + '.hours.wed.closed'}
                        onClick={() => {disableAllForDay('wed', props.day.hours.wed.closed, detailedOperatingHours, cellName);}}
                        value={props.day.hours.wed.closed}
                        checked={props.day.hours.wed.closed}
                        disabled={tableDisabled}
                    />
                </td>
                <td>
                    <TextInput
                        id={props.id + '.hours.thu.closed'}
                        type='checkbox'
                        className='agree-checkbox'
                        name={props.id + '.hours.thu.closed'}
                        onClick={() => {disableAllForDay('thu', props.day.hours.thu.closed, detailedOperatingHours, cellName);}}
                        value={props.day.hours.thu.closed}
                        checked={props.day.hours.thu.closed}
                        disabled={tableDisabled}
                    />
                </td>
                <td>
                    <TextInput
                        id={props.id + '.hours.fri.closed'}
                        type='checkbox'
                        className='agree-checkbox'
                        name={props.id + '.hours.fri.closed'}
                        onClick={() => {disableAllForDay('fri', props.day.hours.fri.closed, detailedOperatingHours, cellName);}}
                        value={props.day.hours.fri.closed}
                        checked={props.day.hours.fri.closed}
                        disabled={tableDisabled}
                    />
                </td>
                <td>
                    <TextInput
                        id={props.id + '.hours.sat.closed'}
                        type='checkbox'
                        className='agree-checkbox'
                        name={props.id + '.hours.sat.closed'}
                        onClick={() => {disableAllForDay('sat', props.day.hours.sat.closed, detailedOperatingHours, cellName);}}
                        value={props.day.hours.sat.closed}
                        checked={props.day.hours.sat.closed}
                        disabled={tableDisabled}
                    />
                </td>
                <td>
                    <TextInput
                        id={props.id + '.hours.sun.closed'}
                        type='checkbox'
                        className='agree-checkbox'
                        name={props.id + '.hours.sun.closed'}
                        onClick={() => {disableAllForDay('sun', props.day.hours.sun.closed, detailedOperatingHours, cellName);}}
                        value={props.day.hours.sun.closed}
                        checked={props.day.hours.sun.closed}
                        disabled={tableDisabled}
                    />
                </td>
            </tr>
            </tbody>
        </table>
    );
};
export default OperatingHours